import { createSlice } from '@reduxjs/toolkit'

import { logoutUser } from '../actions/userActions'
import { AdScheduledEvent } from 'common/types'
import { createAdScheduledEvent } from '../actions/adScheduledEventActions'
import type { ApplicationException } from '../../api/ApplicationException'

interface State {
  scheduledEvents: Array<AdScheduledEvent>
  creating: boolean
  formErrors?: ApplicationException['errorInfo']['details']
}

export const initialAdScheduledEvents: State = {
  scheduledEvents: [],
  creating: false,
  formErrors: undefined,
}

const adScheduledEventSlice = createSlice({
  name: 'adScheduledEvent',
  initialState: initialAdScheduledEvents,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAdScheduledEvent.pending, (state): State => ({ ...state, creating: true }))
      .addCase(createAdScheduledEvent.rejected, (state): State => ({ ...state, creating: false }))
      .addCase(
        createAdScheduledEvent.fulfilled,
        (state, { payload: scheduledEvents }): State => ({
          ...state,
          scheduledEvents: [...scheduledEvents, ...state.scheduledEvents],
          creating: false,
        }),
      )
      .addCase(logoutUser.fulfilled, (): State => initialAdScheduledEvents)
  },
})

export default adScheduledEventSlice.reducer
